import * as PromoCodeCard from './PromoCodeCard/PromoCodeCard.css';
import * as Status from './PromoCodeCard/Status/Status.css';
import * as Code from './PromoCodeCard/Code/Code.css';
export default {
    PromoCodeCard,
    Status,
    Code
};
